import { useNavigate } from "react-router-dom";
import { useWidgetManager } from "../hooks/useWidgetManager";

export default function NavBarComponent() {
  const navigate = useNavigate();
  const name = localStorage.getItem("name");

  const { title } = useWidgetManager();

  const logout = () => {
    localStorage.removeItem("name");
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box">
          <div className="page-title-right">
            <ul className="topbar-menu d-flex align-items-center gap-3 list-unstyled">
              <li className="dropdown">
                <a
                  className="nav-link dropdown-toggle arrow-none nav-user px-2"
                  data-bs-toggle="dropdown"
                  href="#"
                  role="button"
                  aria-haspopup="false"
                  aria-expanded="false"
                >
                  <span className="account-user-avatar">
                    <img
                      src="/assets/images/users/avatar-1.jpg"
                      alt="user-image"
                      width={32}
                      className="rounded-circle"
                    />
                  </span>
                  <span className="d-lg-flex flex-column gap-1 d-none">
                    <h5 className="my-0">{name}</h5>
                    <h6 className="my-0 fw-normal">Хэрэглэгч</h6>
                  </span>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown">
                  <a
                    href="javascript:void(0);"
                    className="dropdown-item"
                    onClick={() => navigate("/lock")}
                  >
                    <i className="mdi mdi-lock-outline me-1" />
                    <span>Дэлгэц түгжих</span>
                  </a>
                  <a
                    href="javascript:void(0);"
                    className="dropdown-item"
                    onClick={logout}
                  >
                    <i className="mdi mdi-logout me-1" />
                    <span>Гарах</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <h4 className="page-title text-uppercase">{title}</h4>
        </div>
      </div>
    </div>
  );
}
